/*
 * @Author: your name
 * @Date: 2020-06-24 14:09:35
 * @LastEditTime: 2020-08-28 14:43:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\api\basics.js
 */
import request from '@/utils/request'

// 车辆类别
export const getcategory = () => request({
    url: process.env.VUE_APP_BASIC_API + '/datadictionary/getdatadictionary?Code=Other:VehicleType',
    method: 'GET'
})

// 车辆品牌
export const getbrand = () => request({
    url: process.env.VUE_APP_BASIC_API + '/datadictionary/getdatadictionary?Code=Other:VehicleBrand',
    method: 'GET'
})
// 车辆编号查询
export const getvehicleCodeList = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/VehicleInfo/ddl?keyword=' + data + '&stype=1&status=0',
    method: 'GET'
})
// 条码编号查询
export const getbarCodeList = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/VehicleInfo/ddl?keyword=' + data + '&stype=3&ststus=0',
    method: 'GET'
})
// 型号列表
export const getVehiclemodelList = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/vehiclemodel/list',
    method: 'POST',
    data
})

// 查询车辆信息
export const getvehicleInfoItem = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/VehicleInfo/' + data,
    method: 'GET'
})

// 获取驾驶员列表
export const getDriverList = (data) => request({
    url: process.env.VUE_APP_BASIC_API + '/driver/list',
    method: 'POST',
    data
})
// 维修类型
export const getMaintenanceType = (code) => request({
    url: process.env.VUE_APP_BASIC_API + '/DataDictionary/getdictionaryddl?Code=' + code,
    method: 'get'
})

// 获取车辆详情
export function getCarDetails(id) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/VehicleInfo/' + id,
        method: 'get'
    })
}
// 维修项目列表
export function getMaintenitemList(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/mitemnew/list',
        method: 'post',
        data
    })
}
// 维修项目列表
export function getMaintenitemlistForDropdw(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/mitemnew/listForDropdw',
        method: 'post',
        data
    })
}
// 数据字典下拉请求
export function getDictionarySelect(params) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/DataDictionary/getdictionaryddl',
        method: 'get',
        params
    })
}
// 部位部件列表
export function getVehiclepositList(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/vehicleposit/getListByPage',
        method: 'post',
        data
    })
}
// 参数设置查询 （带权限验证）
export function setParameter(params) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/SystemConfig/viewconfig',
        method: 'get',
        params
    })
}
// 通过型号Id与维修项目Id查询工时档案
export function queryhours(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/WorkingHours/queryhours',
        method: 'post',
        data
    })
}
// 根据项目id获取维修工
export function GetworkerByMtId(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/mtWorker/GetworkerByMtId',
        method: 'post',
        data
    })
}
// ynn
// 编号服务
export function getOdd(data) {
    return request({
        url: process.env.VUE_APP_SHEETNO + `/sheetNo/generate?prefix=${data}`,
        method: 'get'
    })
}
//  查询维修队列表信息
export function queryTeamList(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/mteam/getTeamByPage',
        method: 'post',
        data
    })
}
// 工位档案列表
export function stationList(data) {
    return request({
        url: process.env.VUE_APP_BASIC_API + '/station/list',
        method: 'post',
        data
    })
}

